// removed by extract-text-webpack-plugin
module.exports = {"dropdownMenu":"_24phBkeL6Cw1jNmWyCGIzy","dropdown":"_3jBgdUIzb2Xma6h1w4hyey","active":"_2eA_Civh02jAF89wmxMbwQ","dropdownLink":"bhfZVFVpXPdfqr0SNNYr8"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/Dropdown/Dropdown.css
// module id = 1139
// module chunks = 58